export const LOADER_STATUS = 'boilerplate/IMS_COMMON/LOADER_STATUS';
export const STORE_PERIOD_SINGLE = 'boilerplate/IMS_COMMON/STORE_PERIOD';
export const STORE_GSTIN_IMS = 'boilerplate/IMS_COMMON/STORE_GSTIN_IMS';
export const DEFAULT_ENTITY = 'boilerplate/IMS_COMMON/DEFAULT_ENTITY';
export const PROFILE_DATA = 'boilerplate/IMS_COMMON/PROFILE_DATA';
export const SET_ENTITY_LIST = 'boilerplate/IMS_COMMON/SET_ENTITY_LIST';
export const SET_IMS_FETCH_HISTORY = 'boilerplate/IMS_COMMON/SET_IMS_FETCH_HISTORY';


